import { asLink, Content } from '@prismicio/client';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `VideoHeader`.
 */
export type VideoHeaderProps = SliceComponentProps<Content.VideoHeaderSlice>;

/**
 * Component for "VideoHeader" Slices.
 */
const VideoHeader = ({ slice }: VideoHeaderProps): JSX.Element => {
  const {
    video,
    poster_image: posterImage,
    title,
    description,
    button_label: buttonLabel,
    icon,
    button_link: buttonLink,
  } = slice.primary;

  const videoUrl = asLink(video);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="relative -mt-20 pt-20 min-h-[850px]"
    >
      <div className="absolute inset-0">
        {videoUrl && (
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover pointer-events-none transition-opacity"
            poster={posterImage.url!}
          >
            <source src={videoUrl} />
          </video>
        )}
      </div>

      <div className="absolute inset-0 bg-black-gradient" />

      <div className="relative z-10 p-8 flex justify-center items-center py-20 max-w-screen-2xl mx-auto">
        <div className="text-center text-white w-full md:w-3/5 lg:w-1/2 flex flex-col gap-y-11 justify-center items-center">
          {icon.url && <PrismicNextImage field={icon} />}
          <PrismicRichText field={title} />
          <div className="text-xl font-normal">
            <PrismicRichText field={description} />
          </div>
          <PrismicNextLink
            field={buttonLink}
            className="button-bordered-shade-green backdrop-blur-[13px]"
          >
            <span>{buttonLabel}</span>
          </PrismicNextLink>
        </div>
      </div>
    </section>
  );
};

export default VideoHeader;
